import { useEffect, useState } from "react";
import { Button, Dropdown, Skeleton, Space, Table,Tabs } from "antd";

import service from "../../../services/stemiService";
import { recordError } from "../../../utils/logService";

import { DownloadOutlined, FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx-js-style";
import { isAuthorizedRole } from "@seims/shared/src/security";
import moment from "moment";
import DownloadOverviewResults from "./DownloadOverviewResults";
import { map, get } from 'lodash';

import {
  Messages,
  Notify,
  openNotification,
  SearchControl,
  util,
} from '@seims/shared';

const AgentUploadHistory = () => {

  const sortDirections = ['ascend', 'descend', 'ascend'];
  
  const [uploadedFile, setUploadedFile] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [physicalFile, setPhysicalFile] = useState({});
  const [reportUUID, setReportUUID] = useState("");
  const [fileName, setFileName] = useState("");
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const myUploads = "My Uploads";
  const allUploads = "All Uploads";
  const [message, setMessage] = useState("File Upload was successful");
  const [showPDF, setShowPDF] = useState(false);
  const [successful, setSuccessful] = useState(false);
  const [fileUUID, setFileUUID] = useState("");
  const [reportData, setReportData] = useState([]);
  const [currentTab, setCurrentTab] = useState(myUploads);
  const [searchText, setSearchText] = useState("");

  const tabList = [
    {
        key: myUploads,
        label: myUploads,
        children: <Tab1 />,
    },
    {
        key: allUploads,
        label: allUploads,
        children: <Tab2 />,
    },
    
    ];


  useEffect(() => {
    getUploadHistory();
  }, []);

  let msg = "";

  const items = [
    {
      label: "PDF - Overview",
      key: "1",
      icon: <FilePdfOutlined />,
    },
    {
      label: "EXCEL - Detailed",
      key: "2",
      icon: <FileExcelOutlined />,
      disabled: successful,
    },
  ];

  const handleMenuClick = async (e)=> {
      if (e.key == 1) {
        onPDFDownload(reportUUID);
     } else if (e.key == 2) {
        onDownloadExcel(reportUUID);
  
      }
  }

  const handleButtonClick = async (fileUUID, reportUUID, fileName) => {
    setFileUUID(fileUUID);
    setReportUUID(reportUUID);
    setFileName(fileName);

    try 
    {
        const response = await service.downloadOriginalFile(fileUUID);
        if (response) {
          const { data } = response;
          const blobFile = new Blob([data], { type: 'application/octet-stream' });
          setPhysicalFile(blobFile);
        }
    }
    catch(error)
    {
        console.log("ERROR", error);
    }

  };

  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  const onDownloadExcel = async (fileUUID) => {
    const response = await service.downloadReport(fileUUID);
    if (response && response.status === 200) {
      const { data } = response;
     setReportData(data);
    

    const { details: reportData, fileDetails } = data;
    const { filename } = fileDetails;
    generateEXCEL(reportData);
 
  };
}

const generateEXCEL = (reportData) => {
    let commentCount = 0;
    const promise = new Promise((resolve, reject) => {
        const fileReader = new FileReader();
  
        fileReader.readAsArrayBuffer(physicalFile);
        fileReader.onload = (e) => {
          const bufferArray = e.target.result;
          const wb = XLSX.read(bufferArray, { type: "buffer" });
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          const data = XLSX.utils.sheet_to_json(ws);
  
          let colAlias = "";
  
          for (let rowIndex = 0; rowIndex < reportData.length; rowIndex++) {
            //START FROM COLUMN A (StemiName) - COLUMN R (LEARNER RESULTS)
            if (reportData[rowIndex].col === 0) colAlias = "A";
            if (reportData[rowIndex].col === 1) colAlias = "B";
            if (reportData[rowIndex].col === 2) colAlias = "C";
            if (reportData[rowIndex].col === 3) colAlias = "D";
            if (reportData[rowIndex].col === 4) colAlias = "E";
            if (reportData[rowIndex].col === 5) colAlias = "F";
            if (reportData[rowIndex].col === 6) colAlias = "G";
            if (reportData[rowIndex].col === 7) colAlias = "H";
            if (reportData[rowIndex].col === 8) colAlias = "I";
            if (reportData[rowIndex].col === 9) colAlias = "J";
            if (reportData[rowIndex].col === 10) colAlias = "K";
            if (reportData[rowIndex].col === 11) colAlias = "L";
            if (reportData[rowIndex].col === 12) colAlias = "M";
            if (reportData[rowIndex].col === 13) colAlias = "N";
            if (reportData[rowIndex].col === 14) colAlias = "O";
            if (reportData[rowIndex].col === 15) colAlias = "P";
            if (reportData[rowIndex].col === 16) colAlias = "Q";
            if (reportData[rowIndex].col === 17) colAlias = "R";
  
            const currRow = reportData[rowIndex].row + 1;
            const cell = ws[colAlias + currRow];

            if (cell) {
              XLSX.utils.cell_add_comment(
                cell,
                reportData[rowIndex].message,
                "CSIR"
              );
            }
          }
  
          const range = XLSX.utils.decode_range(ws["!ref"]);
  
          for (let i = range.s.r; i <= range.e.r; i++) {
            for (let j = range.s.c; j <= 18; j++) {
              const cell = ws[XLSX.utils.encode_cell({ r: i, c: j })];
  
              const errorFound = reportData.filter(
                (current) => current.row === i && current.col === j
              );
  
              if (cell && errorFound.length > 0) {
                cell.s = { fill: { fgColor: { rgb: "ffff00" } } };
              }
            }
          }
  
          const workbook = XLSX.utils.book_new();
  
          XLSX.utils.book_append_sheet(workbook, ws, wsname);
  
          const fileInfo = fileName.split(".");
          const lastIndex = fileInfo.length - 1;
          XLSX.writeFile(
            wb,
            `${fileInfo[0]}_WITH_COMMENTS.${fileInfo[lastIndex]}`
          );
  
          if (data.length > 0) {
            resolve(data);
          } else {
          }
        };
        FileReader.onerror = (error) => {
          reject(error);
          setLoading(true);
        };
      });
  
      promise.then((d) => { });
}

  const onPDFDownload = async (reportUuid) => {
    try {
      // const response = await service.downloadReport(reportUuid);
      const response = await service.downloadOverviewReport(reportUuid);
      if (response && response.status === 200) {
        const { data } = response;

        if (data.overallStatus === "Data Upload Failed") {
          setShowPDF(true);
          setReportData(data);
          setSuccessful(false);
        } else {
          setShowPDF(true);
          setReportData(data);
          setSuccessful(true);
        }
      }
    } catch (error) {}
  };

  const columns = [
    {
      title: "File Name",
      dataIndex: "filename",
      key: "1",
    },
     {
      title: "Upload Status",
      dataIndex: "overallStatus",
      key: "5",
      sorter: (a, b) => a.overallStatus.localeCompare(b.overallStatus),
    },
    {
      title: "Uploaded Date",
      dataIndex: "uploadDate",
      key: "4",
      render: (text) => {
        return text != null ? moment(text).format("DD MMM YYYY, HH:mm") : "";
      },
      sorter: (a, b) => a.uploadDate.localeCompare(b.uploadDate),
    },
    {
      title: "Download File",
      dataIndex: "file",
      key: "6",
      render: (_, record) => {
        const { fileUuid, filename } = record;
        if (record.id > 0) {
          return (
            <>
              <Space>
                <Button
                  type="primary"
                  icon={<DownloadOutlined />}
                  onClick={() => handleFileDownload(fileUuid, filename)}
                />
              </Space>
            </>
          );
        }
      },
    },
    {
      title: "Download report",
      dataIndex: "download",
      key: "7",
      render: (_, record) => {
        const { fileUuid, reportUuid, filename } = record;
        if (record.id > 0) {
          return (
            <>
              <Space>
               <Dropdown menu={menuProps} onOpenChange={()=>handleButtonClick(fileUuid, reportUuid, filename)}>
                  <Space>
                    <Button type="primary">
                      <FilePdfOutlined />
                    </Button>
                  </Space>
                </Dropdown>
              </Space>
            </>
          );
        }
      },
    },
   ].filter((item) =>
    isAuthorizedRole(["ADMIN"]) ? item : item.visible === undefined
  );

  const tab2columns = [
    {
      title: "File Name",
      dataIndex: "filename",
      key: "1",
    },
    {
      title: "Upload Status",
      dataIndex: "overallStatus",
      key: "5",
      sorter: (a, b) => a.overallStatus.localeCompare(b.overallStatus),
      sortDirections: sortDirections,
    },
    {
      title: "Uploaded Date",
      dataIndex: "uploadDate",
      key: "4",
      render: (text) => {
        return text != null ? moment(text).format("DD MMM YYYY, HH:mm") : "";
      },
      sorter: (a, b) => a.uploadDate.localeCompare(b.uploadDate),
      sortDirections: sortDirections,
    },
    
    {
      title: "Download summary report",
      dataIndex: "download",
      key: "7",
      render: (_, record) => {
        const { fileUuid, reportUuid, filename } = record;
        if (record.id > 0) {
          return (
            <>
              <Space>
               <Dropdown menu={menuProps} onOpenChange={()=>handleButtonClick(fileUuid, reportUuid, filename)}>
                  <Space>
                    <Button type="primary">
                      <FilePdfOutlined />
                    </Button>
                  </Space>
                </Dropdown>
              </Space>
            </>
          );
        }
      },
    },
    {
      title: "Uploader",
      dataIndex: "user",
      key: "8",
      visible: true,
      sorter: (a, b) => a.user.localeCompare(b.user),
      sortDirections: sortDirections,
    },
  ].filter((item) =>
    isAuthorizedRole(["ADMIN"]) ? item : item.visible === undefined
  );

  const getUploadHistory = async () => {
    const entity = "file";
    try {
      setLoading(true);
      const response = await service.getUploadHistory();
      if (response && response.status === 200) {
        var fileData = [];
        const { data } = response;

        fileData = data.map((element) => ({
          fileUuid: element.uploadedFile.uuid.toString(),
          reportUuid: element.uploadReport.uuid.toString(),
          id: element.uploadedFile.id,
          overallStatus: element.overallStatus,
          filename: element.uploadedFile.filename,
          fileSize: `${Math.round(element.uploadedFile.fileSize / 1024, 0)}KB`,
          uploadDate: element.uploadDate,
          user:
            element.userDetails?.firstname + " " + element.userDetails?.surname,
        }));
        setUploadedFile(fileData);
        setFilteredData(fileData);
        setLoading(false);
      } else if (response && response.status === 204) {
        setLoading(false);
        setUploadedFile([]);
        setFilteredData([]);
      } else {
        setUploadedFile([]);
        setFilteredData([]);
      }
    } catch (error) {
      msg = util.parseMessage(Messages.GET_FAILURE, entity);
      openNotification(
        "System failed to load uploaded file details",
        msg,
        Notify.ERROR
      );
      recordError(error);
    }
  };
  const handleFileDownload = async (fileUuid, filename) => {
    try {
      const response = await service.downloadOriginalFile(fileUuid);
      if (response) {
        const { data } = response;
        setPhysicalFile(data);
        const new_blob = new Blob([data]);
        
        const url = URL.createObjectURL(new_blob);
        const downloadLink = document.createElement("a");
        
        downloadLink.href = url;
        downloadLink.download = filename;
        downloadLink.click();
        URL.revokeObjectURL(url);
      }
    } catch (error) {
      msg = util.parseMessage(Messages.FILEDOWNLOAD_FAILURE, "File");
      openNotification("File Download", msg, Notify.ERROR);

      recordError(error);
    }
  };
  
  const onRowChange = (row) => {
    setPageSize(row.pageSize);
  };
  const handleCancel = () => {
    setShowPDF(false);
  };


  const handleInputChange = (e) => {
    const { value: searchValue } = e.target;
    setSearchText(searchValue);
    globalSearch(searchValue);
};

const globalSearch = (searchValue) => {
    if (searchText === "") {
        setFilteredData(filteredData);
        return;
    }

    const reg = new RegExp(
        searchValue.replace(/[.*+\-?^${}()|[\]\\]/g, "\\$&"),
        "gi"
    );

    var _filteredData = map(filteredData, (record) => {
        const statusMatch = get(record, "overallStatus").match(reg);
        const userMatch = get(record, "user").match(reg);
 
        if (!statusMatch && !userMatch) {
            return null;
        }
        return record;
    }).filter((record) => record);

    setSearchText(searchValue);
    setFilteredData(_filteredData);
};



  const title = "History of data uploaded";
  const subTitle = "List of previously uploaded files";
  function Tab1() {
    return (
        <div className="content">
               <h1 className="center-align">History of my uploads</h1>
               <p className="sub-title center-align">{subTitle}</p>
               {loading ? (
                 <Skeleton active avatar />
               ) : (
                 <Table
                   dataSource={filteredData}
                   columns={columns}
                   loading={loading}
                   rowKey={(record) => record.id}
                   bordered
                   pagination={{ pageSize: pageSize }}
                   size="middle"
                   onChange={onRowChange}
                 />
               )}
               <DownloadOverviewResults
                 show={showPDF}
                 successful={successful}
                 onCancel={handleCancel}
                 data={reportData}
               />
             </div> 
    );
  }

  function Tab2() {
    return (
        <div className="content">
               <h1 className="center-align">{title}</h1>
               <p className="sub-title center-align">{subTitle}</p>
               <SearchControl handleInputChange={handleInputChange} searchText={searchText} />
            <div className="space"></div>
               {loading ? (
                 <Skeleton active avatar />
               ) : (
                 <Table
                   dataSource={filteredData}
                   columns={tab2columns}
                   loading={loading}
                   rowKey={(record) => record.id}
                   bordered
                   pagination={{ pageSize: pageSize }}
                   size="middle"
                   onChange={onRowChange}
                 />
               )}
               <DownloadOverviewResults
                 show={showPDF}
                 successful={successful}
                 onCancel={handleCancel}
                 data={reportData}
               />
             </div> 
    );
  }

  return (
    <>
      <Tabs
        type="card"
        className="event-information"
        items={tabList}
        key="1"
        //onChange={onTabChange}
      />
    
    </>
  );

};

export default AgentUploadHistory;
